/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Change role request
 */
export interface ChangeRoleRequest {
  role: ChangeRoleRequest.RoleEnum;
}
export namespace ChangeRoleRequest {
  export const RoleEnum = {
    Admin: 'ADMIN',
    Client: 'CLIENT',
    ClientApiKey: 'CLIENT_API_KEY',
    AdminRead: 'ADMIN_READ',
    SuperAdmin: 'SUPER_ADMIN',
    AdminCompliance: 'ADMIN_COMPLIANCE',
  } as const;
  export type RoleEnum = (typeof RoleEnum)[keyof typeof RoleEnum];
}
